<script>
import { mapGetters } from "vuex";
import {
  colorMap,
  colors,
} from "@/components/modules/new-dashboard/components/organizations-by-region/shared";
import OrganizationsByRegionLabels from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-labels.vue";
import MapChart from "@/shared/charts/map/map-chart.vue";
import TrackerOrganizationsByRegionLabels
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-region/tracker-organizations-by-region-labels.vue";

export default {
  name: "TrackerOrganizationsByRegionMapWidget",
  components: { MapChart, TrackerOrganizationsByRegionLabels },
  data: function() {
    return {
      formatedOrganizationsByCountry: [],
      legend: [1, 2, 3],
      config: {
        width: 400,
        height: 280,
        marginTop: 0,
        //marginRight: 15,
        marginBottom: 0,
        //marginLeft: 100,
        axisLabelSpacePercentage: 0,
      },
    };
  },
  mounted() {
    this.formatOrganizationsByCountry()
  },
  watch: {
    'getTrackerOrganizationsByCountry': {
 handler:     function() {
        this.formatOrganizationsByCountry();
      },deep:true
    }
  },
  computed: {
    colorMap() {
      return colorMap;
    },
    colors() {
      return colors;
    },
    ...mapGetters([
      "getTrackerOrganizationsByCountry",
      "getSelectedTrackerRegionInWidget",
      "getTrackerOrganizationsByRegion",
    ]),
  },
  methods: {
    formatOrganizationsByCountry: function () {
      var max = Math.round(
        Math.max(...this.getTrackerOrganizationsByCountry.data.map((c) => c.count)) *
          1.5
      );
      var min = Math.round(
        Math.min(...this.getTrackerOrganizationsByCountry.data.map((c) => c.count)) *
          0.5
      );

      this.legend = [
        Math.max(min, 3),
        Math.max(Math.round((min + max) / 2), 10),
        Math.max(max, 20),
      ];
     this.formatedOrganizationsByCountry = this.getTrackerOrganizationsByCountry.data.map((country) => {
        return {
          latitude: +country._id.latitude ?? 0,
          longitude: +country._id.longitude ?? 0,
          label: country._id.country,
          value: +country.count,
        };
      });
    },

    getCountries: function () {
      if (!this.getSelectedTrackerRegionInWidget) {
        return [];
      }

      var countriesForRegion = this.getTrackerOrganizationsByRegion.data.filter(
        (region) => region._id.region._id === this.getSelectedTrackerRegionInWidget
      );
      var totals = countriesForRegion.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );
      return countriesForRegion.map((country) => {
        return {
          id: country._id.country._id,
          value: country.count,
          name: this.$t( country._id.country.country),
          originalName: country._id.country.country,
          percentage: (100 * (country.count / totals)).toFixed(0),
        };
      });
    },

    onSelectRegion: function (regionId) {
      //dashboardStore.setSelectedRegionInWidget(regionId);
    },

    onSelectCountry: function (regionId) {
      //dashboardStore.setSelectedRegionInWidget(null);
    },
  },
};
</script>

<template>
  <div>
    <div v-if="getTrackerOrganizationsByRegion.loading" class="loading">
      <!--    <VueSpinner size="20" color="#213a7a"/>-->
    </div>

    <tracker-organizations-by-region-labels
      v-if="getCountries().length"
      style="
        position: absolute;
        left: -190px;
        height: calc(100% - 55px);
        width: calc(100% + 190px);
        overflow: auto;
        top: 45px;
      "
      :colors="colors"
      :chart-data="getCountries()"
      :on-select-region="onSelectCountry"
    />

    <div
      v-if="!getTrackerOrganizationsByCountry.loading"
      style="cursor: pointer"
      class="public-institutions-by-region-map"
      :style="{ opacity: getSelectedTrackerRegionInWidget ? '0.3' : '1' }"
    >
      <map-chart
        :chart-data="formatedOrganizationsByCountry"
        :values-to-show="legend"
        :color="colors"
        :config="config"
        :color-map="colorMap"
        :parent-height="false"
        :point-size="3"
      />
    </div>
  </div>
</template>

<style scoped>
.loading {
  height: 236px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
